export enum UtmSource {
  FACEBOOK = 'fb',
  GOOGLE = 'google',
  TIKTOK = 'tiktok',
  EMAIL = 'email',
  AFFILIATE = 'affiliate',
  BING = 'bing',
  ORGANIC = 'organic',
  DIRECT = 'direct',
  ORIGINAL = 'original',
  WHATSAPP = 'whatsapp',
  SNAPCHAT = 'snapchat',
  NO_SOURCE = '',
}

export const POSSIBLE_UTM_TAGS: Array<keyof UtmTags> = [
  'utm_source',
  'utm_medium',
  'utm_cookies',
  'utm_content',
  'utm_term',
  'utm_campaign_id',
  'utm_campaignid',
  'utm_campaign',
  'utm_adset_id',
  'utm_adsetid',
  'utm_adset',
  'utm_ad_id',
  'utm_adid',
  'utm_ad',
  'gclid',
  'gbraid',
  'iterable_message_id',
  'fbp',
  'fbc',
  'fbclid',
  'ga',
  'everflow_transaction_id',
  'utm_source_retention',
  'utm_adset_name',
  'utm_placement',
  'utm_ad_name',
  'utm_creo_group',
  'ttclid',
  'quizz',
  'oid',
  '_ef_transaction_id',
  'ad_group',
  'fb_test_event_code',
  'tt_test_event_code',
  'seo_channel',
  'seo_landing_page',
  'seo_referrer',
  'utm_emailuser',
  'delivery_id',
  'user_id',
  'ScCid',
  'sg',
  'rd',
  'rf',
];

export type UtmTags = Partial<{
  utm_source: UtmSource;
  utm_cookies: string;
  utm_medium: string;
  utm_content: string;
  utm_term: string;
  utm_campaign_id: string;
  utm_campaignid: string;
  utm_campaign: string;
  utm_adset_id: string;
  utm_adsetid: string;
  utm_adset: string;
  utm_ad_id: string;
  utm_adid: string;
  utm_ad: string;
  gclid: string;
  gbraid: string;
  iterable_message_id: string;
  fbp: string;
  fbc: string;
  fbclid: string;
  ga: string;
  everflow_transaction_id: string;
  utm_source_retention: string;
  utm_adset_name: string;
  utm_placement: string;
  utm_ad_name: string;
  utm_creo_group: string;
  ttclid: string;
  quizz: string;
  oid: string;
  _ef_transaction_id: string;
  ad_group: string;
  fb_test_event_code: string;
  tt_test_event_code: string;
  seo_channel: string;
  seo_landing_page: string;
  seo_referrer: string;
  utm_emailuser: string;
  delivery_id: string;
  user_id: string;
  ScCid: string;
  sg: string;
  rd: string;
  rf: string;
}>;

const notPaidUtmSourceSet = new Set<UtmSource>([
  UtmSource.ORGANIC,
  UtmSource.DIRECT,
  UtmSource.ORIGINAL,
  UtmSource.NO_SOURCE,
]);

export const isUtmTag = (key: string): key is keyof UtmTags =>
  POSSIBLE_UTM_TAGS.includes(key as keyof UtmTags);

export const paidUtmSources = Object.values(UtmSource).filter(
  (source) => !notPaidUtmSourceSet.has(source),
);

export const notPaidUtmSources = Object.values(UtmSource).filter((source) =>
  notPaidUtmSourceSet.has(source),
);
